module.exports = __webpack_public_path__ + "img/shiLaoHua.a5ba0a03.png";